import { processHTML } from "../../../utils/portfolioUtils";
import "../../../css/Resume.css";

const ExperienceItem = ({ exp }) => {
  const hasSubRoles = exp.sub_roles && exp.sub_roles.length > 0;

  return (
    <div className="exp-card">
      <div className="exp-identity">
        <p className="exp-company">{exp.company}</p>
        <h5 className="exp-role">{exp.title}</h5>
        <p className="exp-dates">
          {exp.start_date_display} — {exp.end_date_display}
        </p>
        {exp.tagline && <p className="exp-tagline">{exp.tagline}</p>}
      </div>

      <div className="exp-content">
        {hasSubRoles ? (
          exp.sub_roles.map((role) => (
            <div key={role.id} className="exp-subrole">
              <div className="exp-subrole-label">{role.name}</div>
              <div
                className="exp-subrole-body"
                dangerouslySetInnerHTML={{
                  __html: processHTML(role.description),
                }}
              />
            </div>
          ))
        ) : (
          <div
            className="exp-body"
            dangerouslySetInnerHTML={{ __html: processHTML(exp.description) }}
          />
        )}
      </div>
    </div>
  );
};

export default ExperienceItem;
